import { apiClient } from '../apiClient';

export const PATHS = {
  INVITE_CODE_VALIDITY: '/api/v3/invitecodevalidity',
  INVITE_CODE_USAGE: '/api/v3/invitecodeusage',
} as const;

export type InviteCodeUsageMode =
  | 'GIVE_AND_GET_CREDIT_MODE'
  | 'PREPAID_CREDITS_MODE'
  | 'SINGLE_USE_PER_PERSON_MODE'
  | 'EXTENDED_TRIAL_MODE'
  | 'REFERRAL_MODE'
  | 'PAYING_ORGANIZATION_MODE'
  | string;

export type InviteCodeUsageResponse = {
  code?: InviteCodeUsageMode;
  [key: string]: unknown;
};

export async function validateInviteCode(inviteCode: string): Promise<void> {
  await apiClient.post(PATHS.INVITE_CODE_VALIDITY, { code: inviteCode });
}

export async function recordInviteCodeUsage(inviteCode: string): Promise<InviteCodeUsageResponse> {
  const res = await apiClient.post<InviteCodeUsageResponse>(PATHS.INVITE_CODE_USAGE, {
    code: inviteCode,
  });
  return res.data;
}

export async function validateAndUseInviteCode(
  inviteCode: string
): Promise<InviteCodeUsageResponse> {
  await validateInviteCode(inviteCode);
  return recordInviteCodeUsage(inviteCode);
}
